import { AvatarGroup as MUIAvatarGroup } from '@mui/material';
import { Avatar } from './Avatar';
import { IUser, UserModel } from '@shared/types';
import styled from 'styled-components';

const DEFAULT_MAX_AVATAR = 5;

const StyledMUIAvatarGroup = styled(MUIAvatarGroup)``;

export interface IPersonAvatarProps {
  avatar: UserModel['avatar'];
  gender: UserModel['gender'];
  name: UserModel['name'];
  username: UserModel['username'];
  role: IUser['role'];
}

export const AvatarGroup = ({ max = DEFAULT_MAX_AVATAR, data }: { max?: number; data: IPersonAvatarProps[] }) => {
  return (
    <StyledMUIAvatarGroup max={max}>
      {data.slice(0, max).map(user => (
        <Avatar key={`employee-${user.name}`} src={user.avatar} gender={user.gender} />
      ))}
    </StyledMUIAvatarGroup>
  );
};
